import {
  getData as getLocalStorageData,
  removeData,
  storeData,
} from './local-storage-helper';
import { API_URL } from '../api/config';
import axios from 'axios';
import _get from 'lodash/get';
import { accountLink } from '../constants/endspoints';

const axiosInstance = axios.create({
  baseURL: API_URL,
  // withCredentials: true,
});

const refreshToken = async () => {
  try {
    const authInfo = getLocalStorageData('UBIZNEWS_AUTH_TOKEN');
    const refreshToken = _get(authInfo, 'refresh_token', '');
    const response = await axios.post(`${API_URL}api/token/refresh`, { refresh_token: refreshToken });
    const { token } = response.data;
    storeData(response.data, 'UBIZNEWS_AUTH_TOKEN');

    return token
  } catch (error) {
    throw error;
  }
};


// Request interceptor for API calls

axiosInstance.interceptors.request.use( 
  async (config, data) => {
    const authInfo = getLocalStorageData('UBIZNEWS_AUTH_TOKEN');
    const accessToken = _get(authInfo, 'token', '');
    const regex = /api\/(admin|supadmin)\/.*/;
    if (accessToken && regex.test(config.url)) {
      config.headers = {
        Authorization: `Bearer ${accessToken}`,
      };
    }

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// Response interceptor for API calls
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    if (error?.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true; // Marquer comme "en cours de refresh"
      try {
        const newAccessToken = await refreshToken(); // Obtenir un nouveau token
        originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`; // Ajouter le nouveau token
        return axiosInstance(originalRequest); // Relancer la requête
      } catch (refreshError) {
        console.error('Échec du rafraîchissement du token:', refreshError);
        // Rediriger vers la page de connexion ou gérer une déconnexion
        removeData('UBIZNEWS_AUTH_TOKEN')
        window.location.href = accountLink;
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(_get(error, 'response.data', ''));
  }
);

const ubiznews = axiosInstance;

export default ubiznews;
